import React, {Component} from "react";
import { Col, Container, Row } from "react-bootstrap";
import signalDispatcherInstance from "../utils/signalDispatcher";
import CommonService from "../services/common.service";
import userEventService from "../services/user-event.service";

let common = new CommonService();

interface CompletedPageState {
    paymentStatus: string;
    translations: Record<string, any>;

}

class CompletedPage extends Component<{}, CompletedPageState> {
    constructor(props: any) {
        super(props);
        this.state = {
            paymentStatus: '',
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'completed_page_open');
        localStorage.removeItem('cart');
        localStorage.removeItem('cartExpiryTime');
        localStorage.removeItem('uuid');
        signalDispatcherInstance.emit('updateCartTicket', null);
        common.getUID().then((uid: any) => {
            if (uid && uid.uuid) {
                localStorage.setItem('uuid', uid.uuid);
            }
            else {
                localStorage.setItem('uuid', '');
            }
        });
    }

    render() {
        return (
            <>
                <Container className="oc-mainpage">
                    <Row>
                        <Col key={'pageContent_completed'} lg={6} md={6} sm={12} xs={12}>
                            <h2>
                                {this.state.translations.filter((item: any) => item.setting_name === 'THANKYOU_ORDER')[0].setting_value_text || 'Thank you for your order!'}
                            </h2>
                            <p style={{ marginTop: '32px' }}>
                                {this.state.translations.filter((item: any) => item.setting_name === 'ORDER_PAYMENT_LINK_CHECK')[0].setting_value_text || 'Please check your email for your payment link.'}
                            </p>
                            <p className="highlight">
                                {this.state.translations.filter((item: any) => item.setting_name === 'ORDER_PAYMENT_LINK_HINT')[0].setting_value_text || 'If you do not receive an email within a few minutes, please check your spam folder or contact us.'}
                            </p>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default CompletedPage;